(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('[data-aqua-mega-menu]').forEach((menu) => {
      if (menu.dataset.aquaReady === 'true') return;
      menu.dataset.aquaReady = 'true';

      const details = menu.querySelector('[data-aqua-mega-details]');
      const summary = details && details.querySelector('summary');
      const headerSection = document.getElementById('shopify-section-header');
      let closeTimer;

      if (!details || !summary) return;
      const open = () => {
        window.clearTimeout(closeTimer);
        details.open = true;
        headerSection?.classList.remove('shopify-section-header-hidden');
        headerSection?.classList.add('aqua-header-mega-open');
      };
      const close = (returnFocus = false) => {
        window.clearTimeout(closeTimer);
        details.open = false;
        headerSection?.classList.remove('aqua-header-mega-open');
        if (returnFocus) summary.focus();
      };
      const scheduleClose = () => { closeTimer = window.setTimeout(() => close(), 140); };

      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', scheduleClose);
      menu.addEventListener('focusin', () => window.clearTimeout(closeTimer));
      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget)) scheduleClose();
      });
      details.addEventListener('toggle', () => {
        headerSection?.classList.toggle('aqua-header-mega-open', details.open);
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          close(true);
        }
      });
      document.addEventListener('pointerdown', (event) => {
        if (details.open && !menu.contains(event.target)) close();
      });
    });

    root.querySelectorAll('[data-aqua-country-select]').forEach((select) => {
      if (select.dataset.aquaReady === 'true') return;
      select.dataset.aquaReady = 'true';
      select.addEventListener('change', () => select.form?.submit());
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
